import { Button, CounterPill, Icon } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';

export interface ISurveyNoteButtonProps {
	onClick: () => void;
	hasNote: boolean;
	isDisabled: boolean;
}

export const SurveyNoteButtonContainer = styled.div.attrs<{}>({
	className: 'tws-survey-note-button',
})`
	position: relative;
`;

export class SurveyNoteButton extends React.Component<ISurveyNoteButtonProps> {
	public render() {
		const { hasNote, isDisabled } = this.props;
		return (
			<SurveyNoteButtonContainer>
				<Button size='md' id='SaveNotes' disabled={isDisabled} onClick={this.props.onClick}>
					<Icon name='note' />
					Add Note
				</Button>
				{hasNote ? <CounterPill size='sm' attached={true} actualCount={1} /> : null}
			</SurveyNoteButtonContainer>
		);
	}
}
